// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1WNli","consentsList":"PatientConsents_consentsList__1Z70y","consentsListEmpty":"PatientConsents_consentsListEmpty__1dM37"};